import React, { type CSSProperties, type ReactNode } from 'react';

/**
 * An absolutely position box horizontally and vertically. Requires that the parent be "position: relative"
 */
const absoluteCentered = (props: { children: ReactNode; style?: CSSProperties; centerOfScreen?: boolean }) => {
  const { style, children, centerOfScreen } = props;
  return (
    <div
      style={{
        position: centerOfScreen ? 'fixed' : 'absolute',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        transform: 'translateY(-50%)',
        top: '50%',
        textAlign: 'center',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default absoluteCentered;
